import { connect } from 'react-redux';

import { FavoriteButton, IFavoriteButtonDispatchProps } from '.';
import { IAppState, Dispatch } from '../../../../common/state';
import { setNewbuildingFavorite } from '../../../state/newbuilding_info';

export const FavoriteButtonContainer = connect(
  (state: IAppState) => ({
    newbuildingInfo: state.results.newbuildingInfo,
  }),
  (dispatch: Dispatch): IFavoriteButtonDispatchProps => ({
    setFavorite: (isFavorite, newbuildingId) => dispatch(setNewbuildingFavorite(isFavorite, newbuildingId)),
  }),
)(FavoriteButton);
